import $store from '@/store'

export default [
  {
    path: '/compare-loans',
    component: () => import('@/pages/compare-loans/Index.vue'),
    beforeEnter(to, from, next) {
      //  loanOffers 없으면 폼으로 이동
      const loanOffers = $store.state.loanMarketplace?.loanOffers
      const formRouteName = 'compare-loans/form'
      if (to.name != formRouteName && !loanOffers?.length > 0) {
        next({ name: 'compare-loans/form' })
      } else {
        next()
      }
    },
    children: [
      {
        name: 'compare-loans',
        path: '',
        meta: {
          // requireSignin: false,
          layout: 'DefaultLayout',
          design: { noTopHeader: true, classes: ['fill-height'] },
          ui: {
            footer: true,
            header: {
              title: '이용 가능한 사업자 신용 대출',
              backButton: true,
            },
          },
        },
        component: () => import('@/pages/compare-loans/CompareLoans.vue'),
      },
      {
        name: 'compare-loans/form',
        path: 'form',
        meta: {
          // requireSignin: false,
          layout: 'DefaultLayout',
          design: { noTopHeader: true, classes: ['fill-height'] },
          ui: {
            footer: true,
            header: {
              title: '이용 가능한 사업자 신용 대출',
              backButton: true,
            },
          },
        },
        component: () => import('@/pages/compare-loans/Form.vue'),
      },
      {
        name: 'compare-loans/detail',
        path: ':uuid',
        meta: {
          // requireSignin: false,
          layout: 'DefaultLayout',
          design: { noTopHeader: true, classes: ['fill-height'] },
          ui: {
            footer: true,
            header: {
              title: '대출 신청하기',
              backButton: true,
              backTo: {
                name: 'compare-loans',
              },
            },
          },
        },
        beforeEnter(to, from, next) {
          next()
        },
        component() {
          return import('@/pages/compare-loans/CompareLoansDetail.vue')
        },
      },
      {
        name: 'compare-loans/detail/complete',
        path: ':uuid/complete',
        meta: {
          // requireSignin: false,
          layout: 'DefaultLayout',
          design: { noTopHeader: true, classes: ['fill-height'] },
          ui: {
            footer: true,
            header: {
              title: '대출 신청 완료',
              backButton: true,
              backTo: {
                name: 'main',
              },
            },
          },
        },
        beforeEnter(to, from, next) {
          next()
        },
        component() {
          return import('@/pages/compare-loans/CompareLoansDetailComplete.vue')
        },
      },
    ],
  },
]
